import { FunctionComponent, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { useNavigate, useParams } from "react-router-dom";
import { isCnpj, isCpf } from "validator-brazil";
import { useCheckout } from "../../context/CheckoutContext";
import styles from "../../pages/CheckoutData/CheckoutDados.module.css";
import ApiService from "../../service/ApiService";
import { Constants } from "../../utils/constants";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

const FormDataComponent: FunctionComponent = ({
  onSubmit,
  setChecks,
  checks,
  errors,
  setErros,
  disabled,
  setDisabled,
  handleContinue
}: {
  onSubmit: boolean;
  setChecks: (
    { policy, privacy }: { policy: boolean, privacy: boolean }
  ) => void;
  checks: { policy: boolean, privacy: boolean };
  errors: {
    document_number_ErrorMsg: string,
    telephone_ErrorMsg: string,
    name_ErrorMsg: string,
    lastname_ErrorMsg: string,
    email_ErrorMsg: string,
    allfields_ErrorMsg: string,
    overlimits_ErrorMsg: string
  };
  setErros: (value: any) => void;
  disabled: boolean;
  setDisabled: (value: boolean) => void;
  handleContinue: () => void;
}) => {
  const width = window.innerWidth;

  const apiService = new ApiService();
  const [documentType, setDocumentType] = useState("CPF");
  const navigate = useNavigate();
  const params = useParams();
  const { setPurchaserData, cart, purchaser } = useCheckout();
  const [generalInfo, setGeneralInfo] = useState({
    terms: "",
    policy: "",
    limitDate: "",
  });
  const handleSelectDocType = ({ target: { value } }) => {
    setDocumentType(value);
    setErros({
      ...errors,
      document_number_ErrorMsg:
        value === "CPF" ? "CPF invalido" : "CPNJ invalido",
    });
  };

  const handleDocumentValueChange = ({ target: { value } }) => {
    if (
      (documentType === "CPF" ? isCpf(value) : isCnpj(value)) &&
      value !== ""
    ) {
      setPurchaserData({ ...purchaser, document_number: value });
      setErros({ ...errors, document_number_ErrorMsg: "" });
    } else {
      if (value.replace(/\D/g, "") !== "") {
        setPurchaserData({ ...purchaser, document_number: value });
        setErros({
          ...errors,
          document_number_ErrorMsg:
            documentType === "CPF" ? "CPF invalido" : "CPNJ invalido",
        });
      } else {
        setErros({ ...errors, document_number_ErrorMsg: "" });
        setPurchaserData({ ...purchaser, document_number: "" });
      }
    }
  };
  const verifyLength = () => {
    if (purchaser.name.length + purchaser.lastname.length > 63) {
      const errorMessage = documentType !== 'CNPJ'? "Nome e sobrenome devem ter no máximo 63 caracteres." : "Razão social e nome fantasia devem ter no máximo 64 caracteres.";
      setErros({ ...errors, overlimits_ErrorMsg: errorMessage})
    } else {
      setErros({ ...errors, overlimits_ErrorMsg: ""})
    }
  };

  const handleTextValueChange = ({ target: { value, name } }) => {
    const otherFieldLength = name === 'name' ? purchaser.lastname.length : purchaser.name.length;
  
    const combinedLength = value.length + otherFieldLength;
  
    if (combinedLength > 63 && value.length > purchaser[name].length) {
      const errorMessage = documentType !== 'CNPJ'
        ? "Nome e sobrenome devem ter no máximo 63 caracteres."
        : "Razão social e nome fantasia devem ter no máximo 63 caracteres.";
      setErros({ ...errors, overlimits_ErrorMsg: errorMessage });
    } else {
      setPurchaserData({ ...purchaser, [name]: value });
      setErros({ ...errors, overlimits_ErrorMsg: "" });
    }
  };
  const handlePhoneValueChange = ({ target: { value } }) => {
    if (value.replace(/\D/g, "").length >= 11) {
      setPurchaserData({ ...purchaser, telephone: value });
      setErros({ ...errors, telephone_ErrorMsg: "" });
    } else {
      if (value.replace(/\D/g, "") !== "") {
        setPurchaserData({ ...purchaser, telephone: value });
        setErros({
          ...errors,
          telephone_ErrorMsg: "insira um telefone válido",
        });
      } else {
        setErros({ ...errors, telephone_ErrorMsg: "" });
        setPurchaserData({ ...purchaser, telephone: "" });
      }
    }
  };
  const handleEmailValueChange = ({ target: { value, name } }) => {
    if (emailRegex.test(value)) {
      setPurchaserData({ ...purchaser, [name]: value });
      setErros({ ...errors, email_ErrorMsg: "" });
    } else {
      if (value !== "") {
        setPurchaserData({ ...purchaser, email: value });
        setErros({ ...errors, email_ErrorMsg: "Insira um Email válido" });
      } else {
        setErros({ ...errors, email_ErrorMsg: "" });
        setPurchaserData({ ...purchaser, email: "" });
      }
    }
  };

  useEffect(() => {
    apiService.getTermsAndPolicy().then(({ terms, policy, limitDate }) => {
      setGeneralInfo({ terms, policy, limitDate });
    });
  }, []);

  useEffect(() => {
    setDisabled(false)
    if (Object.values(checks).every((x) => x)) {
      if (errors.allfields_ErrorMsg === "Por favor, aceite os Termos de Uso e a Política de Privacidade.") {
        setErros({
          ...errors,
          allfields_ErrorMsg: "",
        })
      }
    } else setDisabled(true);
    if (Object.values(purchaser).some((x) => x === "")) setDisabled(true)
    else {
      if (errors.allfields_ErrorMsg === "Preencha todos os dados") setErros({
        ...errors,
        allfields_ErrorMsg: "",
      })
    }
    if (Object.values(errors).some((x) => x !== "")) setDisabled(true)
  }, [errors, checks, purchaser]);

  /*useEffect(() => {
    if (
      Object.values(purchaser).some((x) => x === "") &&
      Object.values(checks).some((x) => x)
    ) {
      setErros({
        ...errors,
        allfields_ErrorMsg: "Preencha todos os dados",
      });
    } else {
      setErros({
        ...errors,
        allfields_ErrorMsg: "",
      });
    }
  }, [checks, purchaser]);*/

  return (
    <>
      <form className={styles.dados}>
        <div className={styles.textFields1}>
          <div className={styles.document}>
            <label htmlFor="CPF">
              <input
                type="radio"
                className={styles.label}
                onChange={handleSelectDocType}
                checked={documentType === "CPF"}
                value="CPF"
              ></input>
              <span className={styles.radioInputText}>CPF</span>
            </label>

            <label htmlFor="CNPJ">
              <input
                type="radio"
                className={styles.label}
                onChange={handleSelectDocType}
                checked={documentType === "CNPJ"}
                value="CNPJ"
              ></input>
              <span className={styles.radioInputText}>CNPJ</span>
            </label>
            <span className={styles.span}>*</span>
          </div>
          <InputMask
            mask={
              documentType === "CPF" ? "999.999.999-99" : "99.999.999/9999-99"
            }
            value={purchaser.document_number}
            className={styles.content}
            onChange={handleDocumentValueChange}
          />
        </div>
        <div className={styles.nomesobrenome}>
          <div className={styles.textFields1}>
            <div className={styles.div}>
              <span>{documentType !== 'CNPJ' ? 'Nome' : 'Razão social'}</span>
              <span className={styles.span}>*</span>
            </div>
            <input
              className={styles.content}
              onChange={handleTextValueChange}
              value={purchaser.name}
              onBlur={verifyLength}
              name="name"
            ></input>
          </div>
          <div className={styles.textFields1}>
            <div className={styles.div}>
              <span>
                {documentType !== 'CNPJ' ? 'Sobrenome' : 'Nome fantasia'}
              </span>
              <span className={styles.span}>*</span>
            </div>
            <input
              className={styles.content}
              name="lastname"
              value={purchaser.lastname}
              onBlur={verifyLength}
              onChange={handleTextValueChange}
            ></input>
          </div>
        </div>
        <div className={styles.nomesobrenome}>
          <div className={styles.textFields1}>
            <div className={styles.div}>
              <span>E-mail</span>
              <span className={styles.span}>*</span>
            </div>
            <input
              className={styles.content}
              name="email"
              value={purchaser.email}
              onChange={handleEmailValueChange}
            ></input>
          </div>
          <div className={styles.textFields1}>
            <div className={styles.div}>
              <span>Whatsapp/Celular</span>
              <span className={styles.span}>*</span>
            </div>
            <InputMask
              className={styles.content}
              mask="(99)99999-9999"
              value={purchaser.telephone}
              onChange={handlePhoneValueChange}
            ></InputMask>
          </div>
        </div>
        {Object.values(errors).map((x) =>
          x !== "" ? (
            <p className={styles.span} key={x}>
              {x}*
            </p>
          ) : null
        )}
      </form>
      <div className={styles.termos}>
        <div className={styles.checkbox}>
          <input
            className={styles.checkbox1}
            onChange={() => setChecks({ ...checks, policy: !checks.policy })}
            type="checkbox"
          />
          <div className={styles.placeholder}>
            <span>Li e aceito os </span>
            <a
              className={styles.termosECondies}
              href={generalInfo.terms}
              target="_blank"
              rel="noreferrer"
            >
              Termos e Condições de Uso
            </a>
          </div>
        </div>
        <div className={styles.checkbox}>
          <input
            className={styles.checkbox1}
            onChange={() => setChecks({ ...checks, privacy: !checks.privacy })}
            type="checkbox"
          />
          <div className={styles.placeholder}>
            <span>Li e concordo com a </span>
            <a
              className={styles.termosECondies}
              href={generalInfo.policy}
              target="_blank"
              rel="noreferrer"
            >
              Política de Privacidade
            </a>
          </div>
        </div>
      </div>
      {width > 800 && (
        <div
          className={`${styles.btnDisabled}
           ${styles.checkoutButtonContainer}`}
        >
          <button
            className={
              !disabled && cart.length !== 0 ? styles.cta : styles.disabled
            }
            onClick={() => {
              handleContinue();
            }}
            disabled={disabled && cart.length === 0}
          >
            <img className={styles.icones12} alt="" src="/icones4.svg" />
            <div className={styles.div}>
              <span className={styles.btnEntrega}>Continuar para entrega</span>{" "}
            </div>
            <img className={styles.icones} alt="" src="/icones5.svg" />
          </button>
        </div>
      )}

    </>
  );
};

export default FormDataComponent;
